module.exports = __webpack_public_path__ + "assets/img/1.cfcac599.png";